<ng-container *transloco="let t">
  <section
    *ngIf="discount"
    [class.flag-mode]="flagMode"
    [class.good-deal-mode]="goodDealMode"
    [class.red-color]="redColor"
    [class.rtl]="isRtl$ | async"
    class="featured-discount-badge">
    <span *ngIf="!goodDealMode" dir="ltr">{{ discount }}%</span>
    <span *ngIf="goodDealMode">{{ t('txt_up_to_discount', { var1: -discount }) }}</span>
  </section>
</ng-container>
